import { render, staticRenderFns } from "./DialogActions.vue?vue&type=template&id=85fabebe&scoped=true"
import script from "./DialogActions.vue?vue&type=script&lang=js"
export * from "./DialogActions.vue?vue&type=script&lang=js"
import style0 from "./DialogActions.vue?vue&type=style&index=0&id=85fabebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fabebe",
  null
  
)

export default component.exports